import React, { useEffect, useState } from "react";
import loadable from '@loadable/component';
import { IoMdPerson } from "@react-icons/all-files/io/IoMdPerson";
import { HiOutlineSparkles } from "react-icons/hi2";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FaQuestionCircle } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import { useConfig } from "../../hooks/use-config";
import "./style.scss";

const ReactJson = loadable(() => import('react-json-view'));


const EvResultUIComp = ({ evResult }) => {
  const { clearout: clearoutConfig } = useConfig();

  const [showJsonView, setShowJsonView] = useState(false);

  useEffect(() => {
    setShowJsonView(false);
  }, [evResult]);


  const handleShowJsonClick = () => {
    setShowJsonView(!showJsonView);
  }

  return (
    <div className="d-flex flex-column">
      {showJsonView && evResult && evResult.data ? (
        <div className="result-json-view">
          <ReactJson
            src={evResult.data}
            theme="monokai"
            enableClipboard={true}
            displayDataTypes={false}
            displayObjectSize={false}
            iconStyle="circle"
            name={false}
            style={{
              width: '410px',
              padding: '10px',
              overflowY: 'scroll',
              overflowX: 'auto',
              scrollbarWidth: 'thin',
              maxHeight: '600px',
              borderRadius: '10px',
              textAlign: 'left',
            }}
          />
        </div>
      ) : (
        <>
          {evResult.status === "success" && (
            <div className="d-flex justify-content-center pt-4">
              <div className="ev-result">
                <div className="d-flex justify-content-center pb-2">
                  <IoMdPerson size={50} />
                </div>
                <div
                  className={`d-flex evresultshow justify-content-center pb-3  
                ${evResult.data.safe_to_send === "yes" && "text-success"}
                ${evResult.data.safe_to_send === "no" && "text-danger"}
                ${evResult.data.safe_to_send === "risky" && "text-warning"}
                `}
                >
                  {evResult.data.email_address}
                </div>
                {evResult.data.suggested_email_address && (
                  <div
                    className="d-flex justify-content-center pb-3"
                    style={{ color: "grey", fontWeight: "normal" }}
                  >
                    Did you mean&nbsp;
                    <span style={{ color: "#080849" }}>
                      {evResult.data.suggested_email_address}?
                    </span>
                  </div>
                )}
                {evResult.data.ai_verdict &&
                  < div className="d-flex justify-content-center flex-column align-items-center ai-verdict_msg">
                    <span className="text-secondary text-center fs-6 fw-bold">
                      <span className="ai-icon">
                        <HiOutlineSparkles className="ai-icon_svg" />
                      </span>
                      AI Verdict
                    </span>
                    <span className="text-center">
                      {evResult.data.ai_verdict}
                    </span>
                  </div>
                }
                <div className="d-flex justify-content-center ev-result_content">
                  <div className="flex-item-equal-width justify-content-end">
                    Is Safe to Send?
                  </div>
                  <div className="flex-item-equal-width justify-content-start">
                    {evResult.data.safe_to_send === "yes" && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="yesTooltip">
                            <div className="custom-tooltip">
                              <span className="text">
                                Based on best practices followed in the industry,
                                Safe To Send flag will provide one of the 4 values
                                to know the deliverability chances<br></br>
                                <b>Yes</b> - Valid mailbox addresses with guaranteed
                                deliverability of the message, thus helping to keep
                                the sender reputation high
                                <br></br>
                                <b>No</b> - Invalid mailbox addresses can be safely
                                removed. Trying to send a message will result in a
                                bounce and degrade the sender reputation<br></br>
                                <b>Risky</b> - Contact these email addresses only
                                when the bounce rate is less than 5% or when using
                                your own email sending service<br></br>
                                <b>Unknown</b> - Due to unavoidable reasons, the
                                status of the email cannot be determined, so retry
                                before using them
                              </span>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span>
                          <span className="text-success">Yes</span>&nbsp;
                          <FaQuestionCircle
                            className="ml-1"
                            size={16}
                            style={{ color: "#6c757d" }}
                          />
                        </span>
                      </OverlayTrigger>
                    )}
                    {evResult.data.safe_to_send === "no" && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="noTooltip">
                            <div
                              className="custom-tooltip"
                              style={{ maxWidth: "300px" }}
                            >
                              <span className="text">
                                Based on best practices followed in the industry,
                                Safe To Send flag will provide one of the 4 values
                                to know the deliverability chances<br></br>
                                <b>Yes</b> - Valid mailbox addresses with guaranteed
                                deliverability of the message, thus helping to keep
                                the sender reputation high
                                <br></br>
                                <b>No</b> - Invalid mailbox addresses can be safely
                                removed. Trying to send a message will result in a
                                bounce and degrade the sender reputation<br></br>
                                <b>Risky</b> - Contact these email addresses only
                                when the bounce rate is less than 5% or when using
                                your own email sending service<br></br>
                                <b>Unknown</b> - Due to unavoidable reasons, the
                                status of the email cannot be determined, so retry
                                before using them
                              </span>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span>
                          <span className="text-danger">No</span>&nbsp;
                          <FaQuestionCircle
                            className="ml-1"
                            size={16}
                            style={{ color: "#6c757d" }}
                          />
                        </span>
                      </OverlayTrigger>
                    )}
                    {evResult.data.safe_to_send !== "yes" &&
                      evResult.data.safe_to_send !== "no" &&
                      evResult.data.safe_to_send}
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Email Status
                  </div>
                  <div
                    className={`flex-item-equal-width justify-content-start text-capitalize 
                            ${evResult.data.status === "valid" && "text-success"
                      }
                            ${evResult.data.status === "invalid" &&
                      "text-danger"
                      }
                            ${evResult.data.status === "catch_all" &&
                      "text-warning"
                      }`}
                  >
                    {evResult.data.status === "valid" && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="validTooltip">
                            <div className="custom-tooltip">
                              <span className="text">
                                What does Status value means?<br></br>
                                <b>Valid</b> - Secure, go ahead and send<br></br>
                                <b>Invalid</b> - Don't send, drop these emails
                                <br></br>
                                <b>Catch-all</b> - Maybe, at your own risk
                                <br></br>
                                <b>Unknown</b> - Don't send, verify later an hour to
                                know the status
                              </span>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span>
                          Valid&nbsp;
                          <FaQuestionCircle
                            className="ml-1"
                            size={16}
                            style={{ color: "#6c757d" }}
                          />
                        </span>
                      </OverlayTrigger>
                    )}
                    {evResult.data.status === "invalid" && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="invalidTooltip">
                            <div className="custom-tooltip">
                              <span className="text">
                                What does Status value means?<br></br>
                                <b>Valid</b> - Secure, go ahead and send<br></br>
                                <b>Invalid</b> - Don't send, drop these emails
                                <br></br>
                                <b>Catch-all</b> - Maybe, at your own risk
                                <br></br>
                                <b>Unknown</b> - Don't send, verify later an hour to
                                know the status
                              </span>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span>
                          Invalid&nbsp;
                          <FaQuestionCircle
                            className="ml-1"
                            size={16}
                            style={{ color: "#6c757d" }}
                          />
                        </span>
                      </OverlayTrigger>
                    )}
                    {evResult.data.status === "catch_all" && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="validTooltip">
                            <div className="custom-tooltip">
                              <span className="text">
                                A catch_all email account is an address that is
                                specified to receive all messages that are addressed
                                to an incorrect email address for a domain
                              </span>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span>
                          catch_all&nbsp;
                          <FaQuestionCircle
                            className="ml-1"
                            size={16}
                            style={{ color: "#6c757d" }}
                          />
                        </span>
                      </OverlayTrigger>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Reason
                  </div>
                  <div className="flex-item-equal-width justify-content-start">
                    {evResult.data.sub_status.desc}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Account
                  </div>
                  <div className="flex-item-equal-width justify-content-start showevmob">
                    {evResult.data.detail_info.account || (
                      <span className="mySpan">-</span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Domain
                  </div>
                  <div className="flex-item-equal-width justify-content-start">
                    {evResult.data.detail_info.domain || (
                      <span className="mySpan">-</span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Disposable
                  </div>
                  <div className="flex-item-equal-width justify-content-start text-capitalize">
                    {evResult.data.disposable || (<span className="mySpan">-</span>)}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Free Account
                  </div>
                  <div className="flex-item-equal-width justify-content-start text-capitalize">
                    {evResult.data.free || <span className="mySpan">-</span>}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Role Account
                  </div>
                  <div className="flex-item-equal-width justify-content-start text-capitalize">
                    {evResult.data.role || <span className="mySpan">-</span>}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="flex-item-equal-width justify-content-end">
                    Gibberish
                  </div>
                  <div className="flex-item-equal-width justify-content-start text-capitalize">
                    {evResult.data.gibberish || <span className="mySpan">-</span>}
                  </div>
                </div>
              </div>
            </div >
          )}
          {evResult.status === "failed" && evResult.error && evResult.error.code === 1030 ? (
            <div className="d-flex container flex-wrap ev-error">
              <div className="text-danger text-center fs-5">
                You've reached the limit. Create an account for{" "}
                <span className="text-secondary">100 FREE credits</span> & access more!
              </div>
              <div>
                <Button
                  href={clearoutConfig.app.registerUrl}
                  target="_blank"
                  className="btn btn-primary fw-bold"
                >
                  Start for free
                </Button>
              </div>
              <div className="fs-6">No Credit Card Required</div>
            </div>
          ) : (
            <div className="d-flex container flex-wrap ev-error">
              <div className="fw-bolder text-danger">
                {evResult.message
                  ? evResult.message
                  : evResult.error && evResult.error.message
                    ? evResult.error.message
                    : ""}
              </div>
            </div>
          )}
        </>
      )}
      {
        evResult && evResult.data &&
        <span onClick={handleShowJsonClick} className="show-json">
          {showJsonView ? "View in Table" : "View in JSON"}
        </span>
      }
    </div>
  );
};

export default EvResultUIComp;
